export default __webpack_public_path__ + "accb89b6c0f39364287e4c9b5deb51a5.woff2";